import React from 'react';
import './UniversitiesPage.css';  // Ensure the CSS file is linked
import { useNavigate } from "react-router-dom";

const UniversitiesPage = () => {
    const navigate = useNavigate(); // Initialize useNavigate

    const handleClick = (university) => {
        navigate(university.path); // Use university.path here
    };

    // Example data for universities
    const universities = [
        { name: "University of Naples Federico II", image: "https://upload.wikimedia.org/wikipedia/commons/4/40/Universit%C3%A0_degli_Studi_di_Napoli_Federico_II_-_panoramio_%281%29.jpg", path: "/university-page3" },
        { name: "University of Campania Luigi Vanvitelli", image: "https://medschool.it/wp-content/uploads/2023/04/The-University-of-Campania-Luigi-Vanvitelli.jpg", path: "/university-page8" },
        { name: "University of Messina", image: "https://international.unime.it/sites/sten/files/styles/large/public/2022-10/ateneo3.jpg?itok=__MA0vtS", path: "/university-page" },
        { name: "University of Catania", image: "https://pavaedu.com/wp-content/uploads/2020/12/katanya-universitesi-1024x629.jpg", link: "https://www.unict.it/" },
        { name: "University of Bari Aldo Moro", image: "https://pavaedu.com/wp-content/uploads/2019/11/bari-aldo-moro-%C3%BCniversitesi-pavaedu-5532-1.jpg", path: "/university-page6" },
        { name: "Sapienza University of Rome", image: "https://images.shiksha.com/mediadata/images/1453289462phpq2gbwh.jpeg", path: "/university-page5" },
        { name: "Tor Vergata University of Rome", image: "https://web.uniroma2.it/immagine/7962", path: "/university-page2" },
        { name: "University of Bologna", image: "https://uceap.universityofcalifornia.edu/sites/default/files/marketing-images/program-page-images/university-of-bologna-glance.jpg", link: "https://www.unibo.it/" },
        { name: "University of Siena", image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTKf1Dwe7Jnp6Owx4EyCmIgFoUj1wmaFa1NHg&s", link: "https://www.unisi.it/" },
        { name: "University of Cagliari", image: "https://humanisticmanagement.international/wp-content/uploads/2018/06/Universita-di-Cagliari.jpg", link: "https://www.unica.it/it" },
        { name: "Polytechnic University of Marche", image: "https://images.shiksha.com/mediadata/images/1680863008phpS7waUA_g.jpg", path: "/university-page4" },
        { name: "University of Milano-Bicocca", image: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Milano%2C_ca%27_granda%2C_01.jpg/250px-Milano%2C_ca%27_granda%2C_01.jpg", path: "/university-page7"},
        { name: "University of Pavia", image: "https://images.shiksha.com/mediadata/images/1706791292phpS7XZt9_g.jpg", path: "/university-page10" },
        { name: "University of Padua", image: "https://pavaedu.com/wp-content/uploads/2019/10/University-of-Padova-Padova-Universitesi.jpg", link: "https://www.unipd.it/" },
        { name: "University of Turin", image: "https://blog.rmgoe.org/wp-content/uploads/2022/06/University-of-Turin-Italy.jpg", link: "https://www.unito.it/" },
        { name: "University of Parma", image: "https://images.shiksha.com/mediadata/images/1609734930phpN3JXhe.jpeg", path: "/university-page9" },
        { name: "University of Milan (Statale)", image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR-VQXrIh0WXiU7NYCQ6uwsM5k_uqCkXPs8gA&s", path: "/university-page11" },
    ];

    return (
        <div className="universities-container">
            <h1>Universities Offering Medicine and Surgery Programs in English in Italy</h1>
            <div className="region">
                <h2>Southern Italy and Islands</h2>
                <div className="university-grid">
                    {universities.slice(0, 5).map((uni, index) => (
                        <a 
                            key={index} 
                            href={uni.path} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            onClick={(e) => {
                                e.preventDefault(); // Prevent default link behavior
                                handleClick(uni); // Call handleClick with the university object
                            }}
                        >
                            <div className="university-card" style={{ backgroundImage: `url(${uni.image})` }}>
                                <div className="university-name">{uni.name}</div>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
            <div className="region">
                <h2>Central Italy</h2>
                <div className="university-grid">
                    {universities.slice(5, 11).map((uni, index) => (
                        <a 
                            key={index} 
                            href={uni.path} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            onClick={(e) => {
                                e.preventDefault(); // Prevent default link behavior
                                handleClick(uni); // Call handleClick with the university object
                            }}
                        >
                            <div className="university-card" style={{ backgroundImage: `url(${uni.image})` }}>
                                <div className="university-name">{uni.name}</div>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
            <div className="region">
                <h2>Northern Italy</h2>
                <div className="university-grid">
                    {universities.slice(11).map((uni, index) => (
                        <a 
                            key={index} 
                            href={uni.path} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            onClick={(e) => {
                                e.preventDefault(); // Prevent default link behavior
                                handleClick(uni); // Call handleClick with the university object
                            }}
                        >
                            <div className="university-card" style={{ backgroundImage: `url(${uni.image})` }}>
                                <div className="university-name">{uni.name}</div>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default UniversitiesPage;